import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {YesNoSelectorComponent} from './yes-no-selector.component';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [YesNoSelectorComponent],
    exports: [YesNoSelectorComponent],
})
export class YesNoSelectorModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/yesno/selector/yes-no-selector.module.ts